import { useSpring, animated } from '@react-spring/web'
import cn from 'clsx'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Vegan_2: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			scale: 1,
		},
		config: {
			duration: 800,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ scale: 0.4 }, { scale: 1 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path // all
					d="M257 289.13l-22 56.15a9.1 9.1 0 01-11.83 5.16 9 9 0 01-5.35-5.71 7.27 7.27 0 01-.2-.77c-4.36-16-22.31-57.73-24.53-62.89-.16-.34-.23-.52-.23-.52a8.59 8.59 0 01-.88-3.83 9 9 0 0117.33-3.61.32.32 0 000 .09c.91 2 15.52 34.93 17.53 42.74L240 282.48a9.12 9.12 0 0117 6.65zM240.15 209.69c-1.06 2.22-1.83 3.93-2.37 5.24a24.23 24.23 0 00-1.41 3.78c-.13.33-.23.68-.34 1a.16.16 0 000 .1c-.28.93-.52 1.89-.72 2.85-.31 1.45-.56 2.94-.73 4.42a29.5 29.5 0 00-.2 3.1 1 1 0 000 .17.17.17 0 010 .08 44.06 44.06 0 0017.27 36.28c.41-1.12 18.13-48.11 52-72.76 0 0-28.8 25.93-42.42 78.35a42.42 42.42 0 0041.62-4.6 42 42 0 0016.71-27.23.45.45 0 010-.17c0-.11 0-.26.06-.44.05-.58.16-1.54.35-2.85 1.74-12.71 9.89-57.42 39.5-77.16 0 0-29.63-4.86-60.7 3.8a106.6 106.6 0 00-20.77 8.14 2.09 2.09 0 00-.3.14c-.49.25-1 .52-1.44.77-20.2 10.51-30.68 25.1-36.11 36.99zM227.09 173.19v.06c1.48 3.63 2.52 6.44 3.26 8.59a40.68 40.68 0 011.87 6.16c.17.54.29 1.1.43 1.69a.29.29 0 010 .16c.34 1.51.63 3.06.85 4.6.36 2.33.6 4.72.73 7.09.08 1.66.1 3.3 0 4.93a1.13 1.13 0 010 .26.38.38 0 000 .13 68.19 68.19 0 01-31 55.16c-.55-1.82-24.07-78.44-75.42-121.8 0 0 43.22 44.73 59.7 129.41A68.35 68.35 0 0198 211.76a1.28 1.28 0 000-.29v-.69c0-.92-.12-2.46-.28-4.55-1.51-20.34-10.07-92.12-55.19-127.17 0 0 47.58-3.87 96.12 13.85a175.06 175.06 0 0132.14 15.43 3.59 3.59 0 01.47.27l2.21 1.4c30.95 19.24 46.16 43.68 53.62 63.18z"
					className={cn('transition duration-300 ease-in-out', {
						'fill-accent-6': animate,
					})}
				/>
				<path // dot
					d="M222.84 324.96L226.84 315.97"
				/>
			</svg>
		</animated.span>
	)
}

export { Vegan_2 }
